import React from 'react';
import './index.scss';
import { ELD_TOOLTIP } from './../Constants';

// Ported from rd-docs/mockups/tuva-product-label.html -- the bulb icon
// inside the Solutions badge. Uses currentColor so it inherits the label
// text color. Default 13px matches the medium label (.lb-md / 14px text).
export const SolutionsBulbIcon = ({ size = 13 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
    <path d="M9 18h6" />
    <path d="M10 22h4" />
  </svg>
);

// Ported from rd-docs/mockups/tuva-product-label.html -- the clipboard-
// with-check icon inside the Assessment badge (unlocked state).
export const AssessmentClipIcon = ({ size = 13 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="2" />
    <path d="m9 14 2 2 4-4" />
  </svg>
);

export let DraftLabel = ({ className, border }) => {
  return (
    <span
      style={{
        border: border ? border : '',
      }}
      className={`${className} content-label label-draft text-red`}
    >
      Draft
    </span>
  );
};

export let ELDSupportLabel = ({ className, style }) => {
  return (
    <>
      <span
        style={style}
        className={`${className} content-label label-eld-support`}
        data-tooltip-content={ELD_TOOLTIP}
        data-tooltip-id="tuva-tooltip-id"
      >
        ELD Support
      </span>
    </>
  );
};

export let SolutionLabel = ({ className }) => {
  return (
    <span className={`${className} content-label label--tuva-solution`}>
      <SolutionsBulbIcon />
      Solutions
    </span>
  );
};

export let PrivateLabel = ({ className, border }) => {
  return (
    <span
      className={`${className} content-label label-private`}
      style={{
        color: '#00319A',
        border: border ? border : '',
      }}
    >
      <i className="pr-1 ti ti-lock-1 v-align-text-bottom"></i>
      Private
    </span>
  );
};

export let UnderReviewLabel = ({ className, border }) => {
  return (
    <span
      className={`${className} content-label label-private`}
      style={{
        color: '#07378A',
        border: border ? border : '',
      }}
    >
      Under Review
    </span>
  );
};
